<template>
  <div>
    <!--文字按钮-->
    <template v-if="type === 'textBtn'">
      <el-button v-if="wxMpOpenid" type="text" @click="unbind">解绑</el-button>
      <el-button v-else type="text" @click="bind">绑定微信</el-button>
    </template>

    <template v-if="type === 'iconBtn'">
      <i
        class="iconfont icon--_weixin font-21 clickable"
        :class="{
          'font-color-third': !wxMpOpenid,
          'font-color-success': wxMpOpenid
        }"
        @click="!wxMpOpenid && bind()"
      ></i>
    </template>

    <!--扫码弹窗-->
    <el-dialog
      title="扫码绑定"
      :visible.sync="wechatDialog"
      width="50rem"
      :center="true"
      :before-close="clearWechatDialog"
      class="dialog"
      :close-on-press-escape="false"
      :append-to-body="false"
    >
      <div class="wechat-login-wrapper">
        <!-- 二维码图片 -->
        <el-image
          v-loading="loading"
          class="qr-image"
          :src="qrCodeUrl"
          @click.native="getBindQrCode"
        >
          <template slot="error">
            <div
              class="image-slot"
              style="width: 100%; display: flex; flex-direction: column; text-align: center;"
            >
              <i class="el-icon-refresh-right"></i>
              <p>点击重新获取二维码</p>
            </div>
          </template>
        </el-image>
        <div v-if="showSuccessCover" class="scan-success">
          <img src="../../assets/images/common/scan-success.png" alt="" />
          <p>绑定成功</p>
        </div>
        <div class="scan-tip">
          <div>使用手机微信扫码</div>
          <div>关注“精彩纵横云采购平台”公众号</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBindWechatQrCodeApi, unbindWeChatApi } from '@/api/user'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'BindWechat',

  props: {
    // 绑定按钮的展示形式
    type: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      wechatDialog: false,
      // 二维码链接地址
      qrCodeUrl: '',
      // 凭证信息
      ticket: '',
      loading: false,
      timer: null,
      // 显示扫码成功
      showSuccessCover: false
    }
  },

  computed: {
    ...mapState('user', ['wxMpOpenid', 'wechatNickname'])
  },

  methods: {
    ...mapActions('user', ['getUserInfo']),

    // 解绑微信
    unbind() {
      this.$confirm('解绑微信', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          unbindWeChatApi()
            .then(res => {
              this.$message.success('解绑成功')
              this.getUserInfo()
            })
            .catch(err => {
              this.$message.error(err.data?.message || '解绑失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },

    bind() {
      this.wechatDialog = true
      this.getBindQrCode()
    },

    clearWechatDialog() {
      this.wechatDialog = false
      clearInterval(this.timer)
      this.qrCodeUrl = ''
      this.ticket = ''
    },

    // 获取绑定微信的二维码
    getBindQrCode() {
      // 保证扫码成功遮罩不出现
      this.showSuccessCover = false
      this.loading = true

      getBindWechatQrCodeApi()
        .then(res => {
          this.qrCodeUrl = res.data?.url || {}
          this.ticket = res.data.ticket

          this.timer = setInterval(() => {
            this.checkBind().then(res => {
              if (res?.thirdPartyAccount?.wxMpOpenid) {
                clearInterval(this.timer)
                this.showSuccessCover = true
                this.timer = setTimeout(() => {
                  this.clearWechatDialog()
                }, 1000)
              }
            })
          }, 1000)
        })
        .catch(err => {
          this.$message.error(err.data.message || '获取二维码失败，请稍后重试')
        })
        .finally(() => (this.loading = false))
    },

    // 检查是否绑定成功
    checkBind() {
      return this.getUserInfo().catch(err => {
        this.$message.error(err.data?.message || '获取安全设置信息失败')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mes-list {
  display: flex;
  align-items: center;
  margin-top: pixel-to-rem($n: 20);
  border-bottom: 1px solid $info-fourth-color;

  .list-left {
    flex: 1;
    text-align: left;

    p:first-child {
      font-size: 16px;
      margin: 10px 0;
    }
    p:last-child {
      color: $text-third-color;
    }
  }
}

.wechat-login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: pixel-to-rem($n: 20);

  .qr-image {
    width: 15rem;
    height: 15rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .image-slot {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: #f5f7fa;
      color: #909399;

      i {
        font-size: 2rem;
      }
    }
  }

  .scan-success {
    width: pixel-to-rem($n: 240);
    height: pixel-to-rem($n: 240);
    background-color: rgba(0, 0, 0, 0.9);
    font-size: pixel-to-rem($n: 16);
    @include text-bold;
    color: $white-color;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    padding-top: pixel-to-rem($n: 25);
    box-sizing: border-box;

    img {
      width: pixel-to-rem($n: 60);
      height: pixel-to-rem($n: 60);
    }
  }

  .scan-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 1.5;
  }
}
</style>
